import styled from "styled-components/macro";
import { BREAKPOINTS } from "theme";

const FooterWrapper = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 16px 40px 22px 51px;
  width: 100%;
  @media (max-width: ${BREAKPOINTS.md}px) {
    flex-direction: column;
    justify-content: flex-end;
  }
`

const FooterText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.textSecondary}
`

export const Footer = () => {
  return (
    <FooterWrapper>
      <FooterText>© CratD2C 2024. All rights reserved</FooterText>
      <FooterText>support@cratd2csmartchain.io</FooterText>
    </FooterWrapper>
  )
}
